import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import MdVisibility from 'react-icons/lib/md/visibility'
import MdVisibilityOff from 'react-icons/lib/md/visibility-off'
import classes from './FormInput.scss'

import FormLabel from '../Label'

// uses createClass over es6 class as to not need to bind internal functions...
export const FormInput = React.createClass({
  propTypes: {
    type: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.any,

    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,

    icon: PropTypes.any,
    iconSubmit: PropTypes.bool,

    input: PropTypes.array // from redux-form
  },

  getDefaultProps: () => ({
    iconSubmit: false,
    type: 'text',
    options: [],
    readOnly: false,
    disabled: false
  }),

  // NOTE: confirm and submit don't work together
  getInitialState: function () {
    return { showing: false }
  },

  toggle: function (status) {
    if (status === undefined) {
      status = !this.state.showing
    }

    this.setState({ showing: status })
  },

  renderWithLabel: function () {
    return <FormLabel {...this.props}>
      {this.renderInput()}
      {this.renderIcon()}
    </FormLabel>
  },

  renderIcon: function () {
    if (!this.props.icon && this.props.type !== 'password') return null

    let icon = this.props.icon
    let Element = 'span' // NOTE: must be capitalized
    let props = {}

    if (this.props.type === 'password') {
      icon = this.state.showing && <MdVisibilityOff /> || <MdVisibility />

      props.onClick = (e) => {
        e.preventDefault()
        this.toggle()
      }
    }

    if (this.props.iconSubmit) { // so that we submit the form via clicking / enter
      Element = 'button'
      props.type = 'submit'
    }

    props.className = cx({
      [classes['icon']]: classes['icon'],
      [classes['icon--unimportant']]: this.props.type === 'password' && !this.state.showing
    })

    return <Element {...props}>{icon}</Element>
  },

  renderInput: function () {
    let className = { [classes['input']]: classes['input'] }
    this.props.options.forEach((option) => {
      className[classes[`input--${option}`]] = classes[`input--${option}`]
    })

    return <input
      className={cx(className)}

      value={this.props.value || ''}
      disabled={this.props.disabled}
      readOnly={this.props.readOnly}
      autoCapitalize='none'
      {...this.props.input}

      onChange={this.props.onChange && ::this.props.onChange}

      type={this.props.type === 'password' && this.state.showing ? 'text' : this.props.type}
      placeholder={this.props.type === 'password' && !this.state.showing
        ? '•'.repeat(this.props.placeholder.length)
        : this.props.placeholder
      }
    />
  },

  render: function () {
    if (this.props.type === 'hidden') return this.renderInput()
    return this.renderWithLabel()
  }
})

export default FormInput



// WEBPACK FOOTER //
// ./src/components/Form/Input/FormInput.js